import React from 'react'
import {
  ButtonBack,
  ButtonNext,
  DotGroup,
} from 'pure-react-carousel'

import { StyledCarouselNavigation, } from './styles'

const CarouselNavigation = () => {
  return (
    <StyledCarouselNavigation>
      <ButtonBack className="move-button">
        <svg
          width="22"
          height="14"
          viewBox="0 0 22 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 7H1M1 7L6.5 1.5M1 7L6.5 12.5"
            stroke="#141414"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ButtonBack>

      <DotGroup style={{
        display: 'flex', gap: '1rem'
      }} />

      <ButtonNext className="move-button">
        <svg
          width="22"
          height="14"
          viewBox="0 0 22 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 7H21M21 7L15.5 1.5M21 7L15.5 12.5"
            stroke="#141414"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ButtonNext>
    </StyledCarouselNavigation>
  )
}

export default CarouselNavigation
